var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChatbotContainer',{ref:"chatbot",attrs:{"product":_vm.product,"messages":_vm.messages,"messagesLoading":_vm.messagesLoading},on:{"re-fetch-data":_vm.reFetchData}})}
var staticRenderFns = []

export { render, staticRenderFns }